// Illustrations du site — images Wikimedia Commons hébergées localement (WebP).
// Affichage EN ENTIER (jamais recadré), alt contenant le terme, légende + crédit cliquable.
// Généré depuis /app/research/final_credits.json — ne pas éditer à la main.

export const LEXIQUE_ILLUS = {
  "abstrait": [
    {
      src: "/images/illu/lex-abstrait.webp",
      w: 1920,
      h: 2400,
      alt: "Abstrait : Formes uniques de la continuité dans l'espace, sculpture d'Umberto Boccioni (1913)",
      caption: "Umberto Boccioni, « Formes uniques de la continuité dans l'espace », 1913, bronze, Metropolitan Museum of Art.",
      credit: "Œuvre d'Umberto Boccioni († 1917) — photo : Metropolitan Museum (CC0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Unique_Forms_of_Continuity_in_Space_MET_DT6411.jpg",
    },
  ],
  "armature": [
    {
      src: "/images/illu/lex-armature.webp",
      w: 1920,
      h: 2685,
      alt: "Armature : la charpente de fer d'Eiffel à l'intérieur du bras de la Statue de la Liberté",
      caption: "L'armature de fer d'Eiffel dans le bras de la Statue de la Liberté, photo HAER.",
      credit: "Statue de Bartholdi († 1904), armature d'Eiffel († 1923) — photo : Jet Lowe, HAER (domaine public)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:ARMATURE_AND_FRAMEWORK_LOOKING_DOWN_FROM_INSIDE_THE_ARM._-_Statue_of_Liberty,_Liberty_Island,_Manhattan,_New_York,_New_York_County,_NY_HAER_NY,31-NEYO,89-219.tif",
    },
  ],
  "assemblage": [
    {
      src: "/images/illu/lex-assemblage.webp",
      w: 1920,
      h: 685,
      alt: "Assemblage : montage provisoire des plaques de cuivre de la Statue de la Liberté, atelier Gaget-Gauthier, Paris, 1883",
      caption: "Assemblage provisoire de la Statue de la Liberté, atelier Gaget-Gauthier, Paris, 1883.",
      credit: "Photogravure d'Albert Fernique († 1898) — domaine public",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Provisional_assembly_of_the_Statue_of_Liberty_in_Paris,_1883.jpg",
    },
  ],
  "bronze": [
    {
      src: "/images/illu/lex-bronze.webp",
      w: 1920,
      h: 3002,
      alt: "Bronze : statuette de la base du Persée de Benvenuto Cellini, Loggia dei Lanzi, Florence",
      caption: "Bronze de la base du « Persée » de Benvenuto Cellini, Loggia dei Lanzi, Florence.",
      credit: "Œuvre de Benvenuto Cellini († 1571) — photo : Rufus46 (CC BY-SA 3.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Perseus,_Benvenuto_Cellini,_Loggia_dei_Lanzi_Florenz-07.jpg",
    },
  ],
  "certificat-authenticite": [
    {
      src: "/images/illu/lex-certificat.webp",
      w: 1920,
      h: 1280,
      alt: "Certificat d'authenticité : cachet du fondeur Henry-Bonnard Bronze Co. (New-York, 1887) gravé sur un bronze",
      caption: "Cachet du fondeur Henry-Bonnard Bronze Co., New-York 1887, sur la statue d'Ambrose Burnside (Providence).",
      credit: "Statue de Launt Thompson († 1894) — photo : Kenneth C. Zirkel (CC BY-SA 4.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Foundry_mark_on_Ambrose_Burnside_Statue_in_Burnside_Park.jpg",
    },
  ],
  "cire-perdue": [
    {
      src: "/images/illu/lex-cire-perdue.webp",
      w: 1280,
      h: 2368,
      alt: "Cire perdue : le modèle en cire avec son réseau de jets avant la coulée",
      caption: "Cire perdue : le modèle en cire équipé de son réseau de jets, prêt pour le moule réfractaire.",
      credit: "Photo : Sailko (CC BY-SA 3.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Fusione_di_un_bronzo_a_cera_persa,_fase_3.JPG",
    },
    {
      src: "/images/illu/lex-cire-perdue-schema.webp",
      w: 633,
      h: 845,
      alt: "Cire perdue : schéma des neuf étapes de la coulée directe à la cire perdue",
      caption: "Les neuf étapes de la coulée directe à la cire perdue (schéma).",
      credit: "Schéma : Verbex (CC BY-SA 3.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Etapes_cire_perdue.png",
    },
  ],
  "ciselure": [
    {
      src: "/images/illu/lex-ciselure.webp",
      w: 1920,
      h: 2560,
      alt: "Ciselure : objet en bronze en cours de ciselure au boulet, atelier du Mobilier national",
      caption: "Objet en bronze en cours de ciselure au boulet, atelier de bronze du Mobilier national.",
      credit: "Photo : PaulineR83 (CC BY-SA 4.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Objet_en_bronze_en_cours_de_ciselure_-_Mobilier_national.jpg",
    },
  ],
  "cotation": [
    {
      src: "/images/illu/lex-cotation.webp",
      w: 1920,
      h: 1385,
      alt: "Cotation : une vente aux enchères, gravure de Charles Maurand (XIXe siècle)",
      caption: "Une vente aux enchères, gravure de Charles Maurand, XIXe siècle (BnF).",
      credit: "Gravure de Charles Maurand († 1904) — BnF (CC0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Vente_aux_enchères,_G.22377.jpg",
    },
  ],
  "epreuve-artiste": [
    {
      src: "/images/illu/lex-epreuve.webp",
      w: 1280,
      h: 1181,
      alt: "Épreuve d'artiste : cachet gravé « Cire perdue A.-A. Hébrard » sur un bronze ancien",
      caption: "Cachet « Cire perdue A.-A. Hébrard » gravé sur un bronze : la marque du fondeur d'art qui accompagne numéros d'épreuve et mentions EA.",
      credit: "Photo : Paris 16 (CC0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Fonderie_Hébrard_signature_(cropped).jpg",
    },
  ],
  "figuratif": [
    {
      src: "/images/illu/lex-figuratif.webp",
      w: 1280,
      h: 2406,
      alt: "Figuratif : la Vénus de Willendorf, figurine paléolithique (v. 25 000 av. J.-C.)",
      caption: "La Vénus de Willendorf, v. 25 000 av. J.-C., calcaire, Naturhistorisches Museum, Vienne.",
      credit: "Œuvre anonyme (Paléolithique) — photo : Matthias Kabel (CC BY 2.5)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Venus_von_Willendorf_01.jpg",
    },
  ],
  "fonte": [
    {
      src: "/images/illu/lex-fonte.webp",
      w: 1920,
      h: 2723,
      alt: "Fonte : coulée du bronze en fusion dans une fonderie, photographie ancienne",
      caption: "Coulée du bronze en fusion dans une fonderie, photographie ancienne (Pays-Bas).",
      credit: "Photographie ancienne anonyme — domaine public",
      creditUrl: "https://commons.wikimedia.org/wiki/File:In_een_fabriek_bij_een_grote_open_haard_staat_een_man_die_met_vloeibaar_materiaal_brons_de,_SFA022005458.jpg",
    },
  ],
  "installation": [
    {
      src: "/images/illu/lex-installation.webp",
      w: 1920,
      h: 1440,
      alt: "Installation : une salle d'exposition vide, espace que l'installation investit et transforme",
      caption: "Une salle d'exposition : l'espace nu que l'installation vient investir et transformer.",
      credit: "Photo : Selbymay (CC BY 4.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Museum_Barberini_Innenraum_leer.jpg",
    },
  ],
  "maquette": [
    {
      src: "/images/illu/lex-maquette.webp",
      w: 1920,
      h: 2881,
      alt: "Maquette : bozzetto en terre cuite du Bernin pour Habacuc et l'ange (v. 1655)",
      caption: "Le Bernin, « Habacuc et l'ange », bozzetto en terre cuite, v. 1655.",
      credit: "Œuvre du Bernin († 1680) — photo : Fabrizio Garrisi (CC0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Gian_Lorenzo_Bernini,_Abacuc_e_l'angelo,_bozzetto,_1655_circa_-FG.jpg",
    },
  ],
  "modelage": [
    {
      src: "/images/illu/lex-modelage.webp",
      w: 1920,
      h: 2415,
      alt: "Modelage : La Main de Dieu d'Auguste Rodin, une main qui modèle une figure dans la matière",
      caption: "Auguste Rodin, « La Main de Dieu », v. 1896-1902, marbre, Metropolitan Museum of Art.",
      credit: "Œuvre d'Auguste Rodin († 1917) — photo : Metropolitan Museum (CC0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:The_Hand_of_God_MET_DT2509.jpg",
    },
  ],
  "monumental": [
    {
      src: "/images/illu/lex-monumental.webp",
      w: 760,
      h: 570,
      alt: "Monumental : l'atelier de Bartholdi avec les maquettes et les sections de la Statue de la Liberté",
      caption: "L'atelier de Bartholdi à Paris, avec les maquettes de la Statue de la Liberté.",
      credit: "Statue de Bartholdi († 1904) — photo : New York Public Library (aucune restriction)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:(View_of_the_workshop,_with_models_of_the_Statue_of_Liberty_-_(3110144440).jpg",
    },
  ],
  "moule": [
    {
      src: "/images/illu/lex-moule.webp",
      w: 1920,
      h: 1019,
      alt: "Moule : moules de fonderie en pierre de l'âge du bronze (1700-1200 av. J.-C.)",
      caption: "Moules de fonderie en pierre, âge du bronze (1700-1200 av. J.-C.).",
      credit: "Moules anonymes (âge du bronze) — photo : Bjoertvedt (CC BY-SA 4.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Bronze_age_1700-1200BC_IMG_1024_moulds.JPG",
    },
  ],
  "patine": [
    {
      src: "/images/illu/lex-patine.webp",
      w: 1920,
      h: 2053,
      alt: "Patine : La Valse de Camille Claudel, bronze à patine brune (1889-1905)",
      caption: "Camille Claudel, « La Valse », 1889-1905, bronze patiné.",
      credit: "Œuvre de Camille Claudel († 1943) — domaine public",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Camille_Claudel,_\"La_Valse\",_1889-1905,_bronze_fonte_(1).jpg",
    },
  ],
  "platre": [
    {
      src: "/images/illu/lex-platre.webp",
      w: 1920,
      h: 1475,
      alt: "Plâtre : la gipsoteca du Liceo Dosso Dossi à Ferrare, moulages en plâtre d'après l'Antique",
      caption: "Moulages en plâtre d'après l'Antique, gipsoteca du Liceo Dosso Dossi, Ferrare.",
      credit: "Moulages d'après l'Antique — photo : Nicola Quirico (CC BY-SA 4.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Gipsoteca,_Liceo_Artistico_Dosso_Dossi,_Ferrara.jpg",
    },
  ],
  "pop-art": [
    {
      src: "/images/illu/lex-pop-art.webp",
      w: 1920,
      h: 1594,
      alt: "Pop art : Lucy the Elephant (1881), bâtiment-enseigne géant en forme d'éléphant, Margate City",
      caption: "Lucy the Elephant, bâtiment-enseigne géant de 1881, Margate City (New Jersey) — l'objet agrandi, ancêtre du pop.",
      credit: "Construit par James V. Lafferty († 1898) — photo : Acroterion (CC BY-SA 4.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Lucy_the_Elephant_NJ3.jpg",
    },
  ],
  "resine": [
    {
      src: "/images/illu/lex-resine.webp",
      w: 1920,
      h: 2560,
      alt: "Résine : objets en résine au démoulage, matériau des tirages contemporains",
      caption: "Objets en résine au démoulage : coulée, inclusion et couleurs franches.",
      credit: "Photo : Aisha Moshood Nifemi (CC BY 4.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Resin_crafts.jpg",
    },
  ],
  "sculpture-urbaine": [
    {
      src: "/images/illu/lex-urbaine.webp",
      w: 1138,
      h: 1500,
      alt: "Sculpture urbaine : fontaine Wallace de la place Louis-Lépine, Paris",
      caption: "Fontaine Wallace, place Louis-Lépine, Paris — la sculpture dans l'espace public.",
      credit: "Fontaine de Charles-Auguste Lebourg († 1906) — photo : Mbzt (CC BY 3.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:P1030930_Paris_IV_fontaines_Wallace_de_la_place_Louis-Lépine_rwk.JPG",
    },
  ],
  "socle": [
    {
      src: "/images/illu/lex-socle.webp",
      w: 1920,
      h: 1440,
      alt: "Socle : plinthe antique portant les pieds d'une statue colossale, Metropolitan Museum",
      caption: "Plinthe en calcaire portant les pieds d'une statue colossale, Antiquité, Metropolitan Museum.",
      credit: "Œuvre anonyme (Antiquité) — photo : Metropolitan Museum (CC0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Limestone_plinth_with_the_feet_of_a_colossal_male_statue_MET_DP212768.jpg",
    },
  ],
  "taille-directe": [
    {
      src: "/images/illu/lex-taille.webp",
      w: 1920,
      h: 2586,
      alt: "Taille directe : un sculpteur taille un relief dans la pierre, photographie ancienne",
      caption: "Un sculpteur taillant un relief dans la pierre, photographie ancienne (Bain News Service).",
      credit: "Photographie ancienne — domaine public (Library of Congress)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Stone_sculptor_at_work.jpg",
    },
  ],
  "terre-cuite": [
    {
      src: "/images/illu/lex-terre-cuite.webp",
      w: 1920,
      h: 2866,
      alt: "Terre cuite : figurine de Tanagra en terre cuite moulée, Grèce, IIIe siècle av. J.-C.",
      caption: "Figurine de Tanagra, terre cuite moulée, Grèce, IIIe siècle av. J.-C., Blanton Museum of Art.",
      credit: "Œuvre anonyme (IIIe s. av. J.-C.) — domaine public",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Statuette_(Tanagra_figurine),_Greek,_3rd_century_BC,_molded_terracotta_-_Blanton_Museum_of_Art_-_Austin,_Texas_-_DSC07615.jpg",
    },
  ],
  "tirage-limite": [
    {
      src: "/images/illu/lex-tirage.webp",
      w: 1920,
      h: 2399,
      alt: "Tirage limité : Thésée combattant le Minotaure, bronze d'édition d'Antoine-Louis Barye",
      caption: "Antoine-Louis Barye, « Thésée combattant le Minotaure », bronze d'édition, musée Fabre.",
      credit: "Œuvre d'Antoine-Louis Barye († 1875) — photo : Finoskov (domaine public)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:SculpturesMuséeFabre31a_Barye_Thésée_&_Minotaure.jpg",
    },
  ],
  "argile": [
    {
      src: "/images/illu/lex-argile.webp",
      w: 1200,
      h: 831,
      alt: "Argile : matières premières du potier et du sculpteur — sable, granit concassé, dégraissants",
      caption: "Les matières de l'argile : sable, granit concassé et dégraissants mélangés à la terre.",
      credit: "Photo : Silar (CC BY-SA 4.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:02021_0507_pottery_raw_materials,_admixtures_to_the_potter%27s_clay.jpg",
    },
  ],
  "ceramique": [
    {
      src: "/images/illu/lex-ceramique.webp",
      w: 960,
      h: 640,
      alt: "Céramique : pots en terre crue en attente de cuisson au four",
      caption: "Pièces de céramique en terre crue, en attente de cuisson.",
      credit: "Photo : Bijay chaurasia (CC BY-SA 4.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Clay_Pots-BW-IMG_7303.jpg",
    },
  ],
  "raku": [
    {
      src: "/images/illu/lex-raku.webp",
      w: 1200,
      h: 797,
      alt: "Raku : pièce de céramique incandescente enfumée dans la sciure enflammée",
      caption: "Cuisson raku : la pièce incandescente est posée dans la sciure qui s'enflamme.",
      credit: "Photo : Dirk Ingo Franke (CC BY-SA 4.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Raku_15.06.2014_11-38-23.jpg",
    },
  ],
  "engobe": [
    {
      src: "/images/illu/lex-engobe.webp",
      w: 960,
      h: 767,
      alt: "Engobe : plat à décor peint en terre liquide colorée, Samarcande, Xe-XIe siècle",
      caption: "Plat à décor d'engobes (terres liquides colorées), Samarcande, Xe-XIe siècle, Dallas Museum of Art.",
      credit: "Œuvre anonyme (Xe-XIe s.) — photo : Dallas Museum of Art (CC0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Flat_plate_with_slip-painted_decoration.jpg",
    },
  ],
};

export const HUB_CIRE_ILLUS = [
  {
    src: "/images/illu/hub-modele.webp",
    w: 1280,
    h: 1280,
    alt: "Cire perdue, étape 1 : le modèle original en plâtre",
    caption: "Étape 1 — Le modèle original, ici en plâtre.",
    credit: "Photo : José-Manuel Benito (CC BY-SA 2.5)",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Lost_Wax-Model_of_apple_in_plaster.jpg",
  },
  {
    src: "/images/illu/hub-empreinte.webp",
    w: 1280,
    h: 1280,
    alt: "Cire perdue, étape 2 : la prise d'empreinte du modèle",
    caption: "Étape 2 — La prise d'empreinte sur le modèle.",
    credit: "Photo : José-Manuel Benito (CC BY-SA 2.5)",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Lost_Wax-Moldmaking_of_an_apple.jpg",
  },
  {
    src: "/images/illu/hub-cire.webp",
    w: 1278,
    h: 1278,
    alt: "Cire perdue, étape 3 : le modèle en cire avec sa tige de coulée",
    caption: "Étape 3 — La cire, tirée de l'empreinte, avec sa tige de coulée.",
    credit: "Photo : José-Manuel Benito (CC BY-SA 2.5)",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Lost_Wax-Model_of_apple_in_paraffine.jpg",
  },
  {
    src: "/images/illu/hub-four.webp",
    w: 1920,
    h: 2678,
    alt: "Cire perdue, étape 4 : le four d'une fonderie, où la cire s'élimine et le moule cuit",
    caption: "Étape 4 — Le four de la fonderie : la cire s'élimine, le moule cuit.",
    credit: "Photo : Jet Lowe, HAER (domaine public)",
    creditUrl: "https://commons.wikimedia.org/wiki/File:INTERIOR,_FOUNDRY,_CASTING_FLOOR,_FURNACE_IN_CONTEXT_-_Ricks_Foundry,_Foundry_Building,_Miller_Avenue_off_South_Mount_Vernon_Street,_Uniontown,_Fayette_County,_PA_HAER_PA,26-UNITO,1A-3.tif",
  },
  {
    src: "/images/illu/hub-coulee.webp",
    w: 816,
    h: 692,
    alt: "Cire perdue, étape 5 : la coulée du métal en fusion depuis le creuset",
    caption: "Étape 5 — La coulée du métal en fusion, photographie ancienne.",
    credit: "Photographie ancienne (Armstrong Whitworth) — domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Pouring_molten_metal_from_the_crucible_pot_into_the_ingot_moulds,_(HS85-10-32646).jpg",
  },
  {
    src: "/images/illu/hub-finition.webp",
    w: 1280,
    h: 1280,
    alt: "Cire perdue, étape 6 : le bronze brut de coulée, avant finition",
    caption: "Étape 6 — Le bronze brut de coulée, avant ébarbage et finition.",
    credit: "Photo : José-Manuel Benito (CC BY-SA 2.5)",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Lost_Wax-Apple_in_bronze.jpg",
  },
];

export const MATERIAU_STEP_ILLUS = {
  "bronze": [
    {
      main: {
        src: "/images/illu/bronze-modele.webp",
        w: 1280,
        h: 841,
        alt: "Bronze, étape 1 : le modèle original en plâtre d'Auguste Rodin (La Mort d'Adonis)",
        caption: "Le modèle original — ici un plâtre d'Auguste Rodin, « La Mort d'Adonis », Walters Art Museum.",
        credit: "Œuvre d'Auguste Rodin († 1917) — domaine public",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Auguste_Rodin_-_The_Death_of_Adonis_-_Walters_27491.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/bronze-fonte.webp",
        w: 1920,
        h: 1531,
        alt: "Bronze, étape 2 : plan et profil d'une fonderie de statues équestres, planche de l'Encyclopédie",
        caption: "« Fonte des statues équestres », plan et profil de la fonderie, planche de l'Encyclopédie de Diderot et d'Alembert.",
        credit: "Gravure de Robert Bénard (né 1734) — domaine public",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Encyclopedie_volume_7-287.png",
      },
    },
    {
      main: {
        src: "/images/illu/bronze-ciselure.webp",
        w: 1920,
        h: 1440,
        alt: "Bronze, étape 3 : bronzes fixés sur les boulets du ciseleur, Mobilier national",
        caption: "Bronzes fixés dans le ciment sur les boulets du ciseleur, atelier du Mobilier national.",
        credit: "Photo : PaulineR83 (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Objets_en_bronze_pris_dans_le_ciment_sur_le_boulet_de_ciseleur_-_Mobilier_national.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/bronze-patine.webp",
        w: 1920,
        h: 2769,
        alt: "Bronze, étape 4 : Le Chinois de Carpeaux, bronze à patine colorée, fonderie Susse (v. 1872)",
        caption: "« Le Chinois », bronze à patine colorée de Jean-Baptiste Carpeaux, fonderie Susse, v. 1872.",
        credit: "Œuvre de Jean-Baptiste Carpeaux († 1875) — photo : Daderot (domaine public)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:The_Chinese_Man_by_Jean-Baptiste_Carpeaux,_foundry_Susse_Freres,_c._1872,_bronze_with_colored_patination_on_marble_base_-_California_Palace_of_the_Legion_of_Honor_-_San_Francisco,_CA_-_DSC00070.jpg",
      },
      extra: {
        src: "/images/illu/bronze-outil-chalumeau.webp",
        w: 1188,
        h: 2000,
        alt: "Le chalumeau à bouche, ancêtre du chalumeau à gaz utilisé aujourd'hui pour la patine à chaud (planche de l'Encyclopédie, XVIIIe siècle).",
        caption: "Le chalumeau à bouche, ancêtre du chalumeau à gaz utilisé aujourd'hui pour la patine à chaud (planche de l'Encyclopédie, XVIIIe siècle).",
        credit: "Planche « Orfèvre Bijoutier, outils » de l'Encyclopédie, 1771 (domaine public)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Recueil_de_planches,_sur_les_sciences,_les_arts_libéraux,_et_les_arts_méchaniques_-_avec_leur_explication_(1771)_(14784050915).jpg",
      },
    },
  ],
  "resine": [
    {
      main: {
        src: "/images/illu/resine-original.webp",
        w: 1920,
        h: 1411,
        alt: "Résine, étape 1 : l'original — modello en terre cuite du Bernin pour la fontaine des Quatre-Fleuves",
        caption: "L'original, sculpté avant tout moulage — ici un modello en terre cuite du Bernin, v. 1650.",
        credit: "Œuvre du Bernin († 1680) — photo : Sailko (CC BY 3.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Gian_lorenzo_bernini,_leone_che_si_abbevera,_modello_in_terracotta_per_la_fontana_dei_fiumi.JPG",
      },
    },
    {
      main: {
        src: "/images/illu/resine-moule.webp",
        w: 1920,
        h: 1291,
        alt: "Résine, étape 2 : le modèle, le moule à pièces ouvert et le tirage, par un mouleur MOF",
        caption: "Le modèle, le moule à pièces ouvert et le tirage, réunis par le mouleur Jacques Laurent (MOF).",
        credit: "Moulage d'après une œuvre ancienne — photo : Jacques Laurent (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Moule_de_la_Vierge_au_Boulanger_par_Jacques_Laurent_MOF.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/resine-coulee.webp",
        w: 921,
        h: 526,
        alt: "Résine, étape 3 : la coulée d'un liquide dans une série de moules en atelier",
        caption: "La coulée dans une série de moules, en atelier (ici en céramique : le geste est le même).",
        credit: "Photo : Encik Tekateki (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Slip_Casting_di_kilang_Claytan.png",
      },
    },
    {
      main: {
        src: "/images/illu/resine-finition.webp",
        w: 1920,
        h: 1298,
        alt: "Résine, étape 4 : une résine poncée et polie, rendu opalescent",
        caption: "Une résine poncée et polie, au rendu opalescent.",
        credit: "Photo : James St. John (CC BY 2.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:\"Aurora_Borealis\"_-_manmade_opalescent_resin_17_-_54574391208.jpg",
      },
    },
  ],
  "platre": [
    {
      main: {
        src: "/images/illu/platre-gachage.webp",
        w: 1920,
        h: 1463,
        alt: "Plâtre, étape 1 : le gâchage du plâtre, gravure ancienne",
        caption: "Le gâchage du plâtre, gravure ancienne (Wellcome Collection).",
        credit: "Gravure ancienne — Wellcome Collection (CC BY 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:One_man_is_mixing_plaster_on_a_board_on_the_floor_and_anothe_Wellcome_V0039549.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/platre-coulee.webp",
        w: 1920,
        h: 3263,
        alt: "Plâtre, étape 2 : moulage en plâtre d'après l'Hermès portant Dionysos antique",
        caption: "Moulage en plâtre d'après l'Antique (Hermès portant Dionysos).",
        credit: "D'après l'Antique — photo : Finoskov (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Moulages_Antique12_Hermès_&_Dionysos.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/platre-reprise.webp",
        w: 1920,
        h: 1280,
        alt: "Plâtre, étape 3 : modèle en plâtre d'une tête de bison sculpté par Alexander Phimister Proctor",
        caption: "Modèle en plâtre d'une tête de bison, sculpté par Alexander Phimister Proctor (1909).",
        credit: "Œuvre d'Alexander Phimister Proctor († 1950) — domaine public (NPS)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Plaster_model_of_a_bison_head_sculpted_by_Alexander_Phimister_Proctor_and_given_to_Theodore_Roosevelt._In_1909,_Theodore_(ff31c65e-b5ed-488a-bc8e-11a34399b3c4).JPG",
      },
    },
    {
      main: {
        src: "/images/illu/platre-finition.webp",
        w: 1920,
        h: 2997,
        alt: "Plâtre, étape 4 : une sculpture en plâtre achevée, Auckland Museum",
        caption: "Une sculpture en plâtre achevée, Auckland Museum.",
        credit: "Photo : Auckland Museum (CC BY 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Sculpture,_plaster_(AM_53809-16).jpg",
      },
    },
  ],
  "metal": [
    {
      main: {
        src: "/images/illu/metal-decoupe.webp",
        w: 1920,
        h: 1440,
        alt: "Métal, étape 1 : la découpe plasma d'une tôle d'acier",
        caption: "La découpe plasma d'une tôle d'acier.",
        credit: "Photo : Diego Baron Carral (CC0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Corte_por_plasma.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/metal-formage.webp",
        w: 600,
        h: 882,
        alt: "Métal, étape 2 : le formage du métal au marteau, gravure de Domenico Beccafumi",
        caption: "Le formage du métal au marteau, gravure de Domenico Beccafumi (XVIe siècle).",
        credit: "Gravure de Domenico Beccafumi († 1551) — domaine public",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Beccafumi_-_8_Producing_small_metal_items.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/metal-soudure.webp",
        w: 1920,
        h: 1440,
        alt: "Métal, étape 3 : la soudure à l'arc d'une tôle d'acier",
        caption: "La soudure à l'arc d'une tôle d'acier.",
        credit: "Photo : Kgequipment (CC BY-SA 3.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Welding_Steel_Plate.JPG",
      },
    },
    {
      main: {
        src: "/images/illu/metal-finition.webp",
        w: 1920,
        h: 1282,
        alt: "Métal, étape 4 : le meulage d'une soudure à la meuleuse d'angle",
        caption: "Le meulage des assemblages à la meuleuse d'angle.",
        credit: "Photo : Adygrafix250 (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:A_welder_using_an_angle_grinder_to_grind_steel.jpg",
      },
    },
  ],
  "bois": [
    {
      main: {
        src: "/images/illu/bois-choix.webp",
        w: 1920,
        h: 1280,
        alt: "Bois, étape 1 : le choix de la pièce — planches de bois et outils sur l'établi",
        caption: "Le choix de la pièce : planches et outils sur l'établi.",
        credit: "Photo : A S M Jobaer (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Woodworking_hand_tools_on_timber_planks_01.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/bois-degrossissage.webp",
        w: 1920,
        h: 1276,
        alt: "Bois, étape 2 : le dégrossissage d'un billot à la tronçonneuse",
        caption: "Le dégrossissage d'un billot à la tronçonneuse.",
        credit: "Photo : Mike Smith (CC BY 2.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Jonnychainsaw_during_a_chainsaw_art_demonstration_at_Muiravonside.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/bois-taille.webp",
        w: 1280,
        h: 909,
        alt: "Bois, étape 3 : un sculpteur sur bois au travail, Japon, 1914",
        caption: "Un sculpteur sur bois au travail, Japon, 1914.",
        credit: "Photo : Elstner Hilton, 1914 (CC BY 2.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Master_Wood_Carver_at_Work_in_Japan_(1914_by_Elstner_Hilton).jpg",
      },
      extra: {
        src: "/images/illu/bois-outils.webp",
        w: 932,
        h: 699,
        alt: "Outils du sculpteur sur bois : ciseaux, gouges et ébauchoirs sur l'établi",
        caption: "Ciseaux, gouges et ébauchoirs à bois sur l'établi.",
        credit: "Photo : David Adam Kess (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Topmast_Studio_(WORKSHOP)_Swiss_Tools_at_the_workbench_Pfeil_Wood_Carving_Tools_Gouges,_Chisels,_Carving_Sets_(pic.z2).jpg",
      },
    },
    {
      main: {
        src: "/images/illu/bois-finition.webp",
        w: 1920,
        h: 1272,
        alt: "Bois, étape 4 : le ponçage d'une planche à la ponceuse",
        caption: "Le ponçage, première étape de la finition du bois.",
        credit: "Photo : Thiam Babel Design (CC0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Ponçage_du_bois._2.jpg",
      },
    },
  ],
  "pierre": [
    {
      main: {
        src: "/images/illu/pierre-choix.webp",
        w: 1920,
        h: 1440,
        alt: "Pierre, étape 1 : le choix du bloc — blocs de marbre dans une carrière de Carrare",
        caption: "Le choix du bloc : carrière de marbre de Carrare.",
        credit: "Photo : Vmenkov (CC BY-SA 3.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Blocks_of_marble_in_Carrara_marble_quarry_6386.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/pierre-degrossissage.webp",
        w: 1000,
        h: 750,
        alt: "Pierre, étape 2 : blocs de pierre dégrossis, la forme commence à émerger",
        caption: "Le dégrossissage : la forme commence à émerger du bloc.",
        credit: "Photo : Carptrash (CC BY-SA 3.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Roughed_out.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/pierre-taille.webp",
        w: 1920,
        h: 1280,
        alt: "Pierre, étape 3 : un tailleur de pierre au travail sur le chantier de Guédelon",
        caption: "Un tailleur de pierre au travail, chantier de Guédelon.",
        credit: "Photo : Schorle (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Stonemason_at_Guedelon.jpg",
      },
      extra: {
        src: "/images/illu/pierre-outil-gradine.webp",
        w: 1920,
        h: 2560,
        alt: "La gradine : traces laissées par la gradine sur la pierre",
        caption: "Traces de gradine sur la pierre : l'outil nivelle et adoucit la surface.",
        credit: "Photo : A.-K. D. (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Claw_tool_marks_Johns_Priory.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/pierre-finition.webp",
        w: 640,
        h: 426,
        alt: "Pierre, étape 4 : les outils de la finition — râpes, gradines et ciseaux du tailleur de pierre",
        caption: "Les outils de la finition : râpes, gradines et ciseaux du tailleur de pierre.",
        credit: "Photo : Magdales (CC BY-SA 3.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Musee_lado_outil_tailleur_pierre.jpg",
      },
    },
  ],
  "terre": [
    {
      main: {
        src: "/images/illu/terre-preparation.webp",
        w: 1200,
        h: 800,
        alt: "Sculpture en argile, étape 1 : pétrissage de la terre à la main pour chasser les bulles d'air",
        caption: "Le pétrissage de la terre avant modelage : chasser l'air, homogénéiser la matière.",
        credit: "Photo : Kritzolina (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Kneten_von_Ton_vor_der_Verarbeitung_01.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/terre-modelage.webp",
        w: 1200,
        h: 1800,
        alt: "Sculpture en argile, étape 2 : « La Charité », bozzetto en terre modelée du Bernin, 1634-1639",
        caption: "« La Charité », bozzetto en terre du Bernin, 1634-1639 — le modelage en plein.",
        credit: "Œuvre du Bernin († 1680) — photo : Fabrizio Garrisi (CC0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Gian_Lorenzo_Bernini,_La_Carit%C3%A0_con_due_putti,_bozzetto_1634-39_-FG.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/terre-sechage.webp",
        w: 1200,
        h: 866,
        alt: "Sculpture en argile, étape 3 : pièces en terre mises à sécher à l'air avant la cuisson",
        caption: "Le séchage à l'air des pièces avant la cuisson, photographie ancienne.",
        credit: "Photo : Library of Congress (domaine public)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Air_drying_pottery_before_kiln_firing._LCCN2016650556.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/terre-cuisson.webp",
        w: 1200,
        h: 777,
        alt: "Sculpture en argile, étape 4 : potiers alimentant le four, pinax corinthien du VIe siècle av. J.-C.",
        caption: "Potiers alimentant le four, pinax corinthien, VIe siècle av. J.-C., Berlin.",
        credit: "Photo : ArchaiOptix (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Corinthian_pinax_-_potters_firing_kiln_-_Berlin_AS_F_608.jpg",
      },
    },
    {
      main: {
        src: "/images/illu/terre-finition.webp",
        w: 1200,
        h: 800,
        alt: "Sculpture en argile, étape 5 : terre cuite émaillée de Luca della Robbia, Vierge à l'Enfant entre deux anges, v. 1470",
        caption: "Terre cuite émaillée : Luca della Robbia, « Vierge à l'Enfant entre deux anges », v. 1470, Bargello, Florence.",
        credit: "Œuvre de Luca della Robbia († 1482) — photo : MenkinAlRire (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Luca_della_Robbia,_Madonna_and_Child_with_Angels,_c1470,_Bargello,_Florence.jpg",
      },
      extra: {
        src: "/images/illu/terre-raku.webp",
        w: 1200,
        h: 798,
        alt: "Finition raku : la pièce incandescente sortie du four est enfumée dans la sciure",
        caption: "Le raku : la pièce incandescente est enfumée dans la sciure.",
        credit: "Photo : Dirk Ingo Franke (CC BY-SA 4.0)",
        creditUrl: "https://commons.wikimedia.org/wiki/File:Raku_15.06.2014_11-38-06.jpg",
      },
    },
  ],
};

export const PARTENAIRE_ILLUS = {
  "ferronnerie": [
    {
      src: "/images/illu/part-forge.webp",
      w: 1920,
      h: 1750,
      alt: "La forge : eau-forte de Charles-Émile Jacque, 1848",
      caption: "« La Forge », eau-forte de Charles-Émile Jacque, 1848 (New York Public Library).",
      credit: "Eau-forte de Charles-Émile Jacque († 1894), 1848 — domaine public",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Forge_(NYPL_b14917537-1219179).jpg",
    },
    {
      src: "/images/illu/part-soudure.webp",
      w: 1024,
      h: 682,
      alt: "La soudure : un soudeur casqué sur des poutrelles d'acier",
      caption: "La soudure à l'arc sur poutrelles d'acier.",
      credit: "Photo : muygocho (CC BY-SA 2.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Red_Lincoln_welding_plant_and_welder_working_on_some_steel_beams.jpg",
    },
    {
      src: "/images/illu/part-decoupe.webp",
      w: 1920,
      h: 1277,
      alt: "Le métal découpé : découpe de tôle, gerbes d'étincelles",
      caption: "La découpe de tôle, en gerbes d'étincelles.",
      credit: "Photo : Carlos Castaneda Giron (CC BY-SA 3.0)",
      creditUrl: "https://commons.wikimedia.org/wiki/File:Cortadora_de_metal.JPG",
    },
  ],
};
